var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4215 10.2231L19.2105 6.72346V9.1817L13.5045 14.931C13.4415 14.9945 13.3418 15.0016 13.2706 14.9478L9.929 12.4226C9.86265 12.3724 9.77079 12.3748 9.70707 12.4283L5.78947 15.7178V14.0196L10.096 8.89138L14.329 10.4423C14.7053 10.5802 15.1264 10.4957 15.4215 10.2231ZM21 5.08396C21 4.14266 19.8895 3.65042 19.2008 4.28649L14.5324 8.59829L10.2388 7.02512C9.81619 6.87029 9.34264 6.99717 9.0522 7.34302L4.25405 13.0566C4.09001 13.2519 4 13.4995 4 13.7554V18.9182C4 19.5156 4.4807 20 5.07368 20H19.9263C20.5193 20 21 19.5157 21 18.9182V5.08396Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkets);
export default __webpack_public_path__ + "static/media/markets.c00603378273cce285106770fbe9f0b6.svg";
export { ForwardRef as ReactComponent };